export function tradeStatusReducer(
    state = {
        hasTradeStatus: false,
    },
    action = {}
) {
    switch (action.type) {
        case 'HAS_TRADE_STATUS': {
            return {
                hasTradeStatus: true,
            };
        }
    }
    return state;
}
